export function testThumbnail(src, type, logger) {
  try {
    const videoEl = document.createElement('video');
    videoEl.setAttribute('width', 100);
    videoEl.setAttribute('height', 100);
    videoEl.setAttribute('muted', true);
    videoEl.setAttribute('src', src);

    videoEl.addEventListener('error', () => {
      logger.signal('fail to load', 'video-player-test');
    });

    const startTime = Date.now();
    videoEl.addEventListener('loadedmetadata', () => {
      logger.signal(`${type}, ${videoEl.duration}`, 'video-player-test');

      if (videoEl.duration === 0 || videoEl.videoWidth === 0 || videoEl.videoHeight === 0) {
        logger.signal('fail to load', 'video-player-test');
      } else {
        logger.signal('success', 'video-player-test');
      }
    });

    videoEl.addEventListener('loadeddata', () => {
      logger.signal(`${type}: ${Date.now() - startTime}; ${videoEl.duration} ${videoEl.videoWidth} ${videoEl.videoHeight}`, 'video-thumbnail-test');
    });
  } catch (error) {
    console.error(error);
  }
}
